var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExistingCustomerMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45,16H32v2h13c0.5517578,0,1,0.4482422,1,1v16c0,0.5517578-0.4482422,1-1,1h-3c-1.1025391,0-2,0.8974609-2,2v3.5859375 c-0.0009766,0.3378906-0.4677734,0.53125-0.7070312,0.2929688l-5-5C33.7265625,36.3125,32.9726562,36,32.171875,36H21 c-0.5517578,0-1-0.4482422-1-1v-7h-2v7c0,1.6542969,1.3457031,3,3,3h11.171875 c0.2626953,0,0.5205078,0.1064453,0.7070312,0.2929688l5,5C38.328125,43.7421875,38.9501953,44,39.5859375,44 C40.9169922,44,42,42.9169922,42,41.5859375V38h3c1.6542969,0,3-1.3457031,3-3V19C48,17.3457031,46.6542969,16,45,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,23V7c0-1.6542969-1.3457031-3-3-3H3C1.3457031,4,0,5.3457031,0,7v16c0,1.6542969,1.3457031,3,3,3l3-0.0019531 v3.5878906C6,30.9169922,7.0830078,32,8.4140625,32c0.6357422,0,1.2578125-0.2578125,1.7070312-0.7070312l5-5 C15.3076172,26.1064453,15.5654297,26,15.828125,26H16h11C28.6542969,26,30,24.6542969,30,23z M15.828125,24 c-0.8007812,0-1.5546875,0.3125-2.1210938,0.8789062l-5,5C8.46875,30.1171875,7.9990234,29.9238281,8,29.5859375V26 c0-1.1025391-0.8974609-2-2-2H3c-0.5517578,0-1-0.4482422-1-1V7c0-0.5517578,0.4482422-1,1-1h24c0.5517578,0,1,0.4482422,1,1v16 c0,0.5517578-0.4482422,1-1,1H16H15.828125z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingCustomerMedium);
export default __webpack_public_path__ + "static/media/existing-customer--medium.3da652183778f77afba8e18ce12245fe.svg";
export { ForwardRef as ReactComponent };